define.alias("ember-composable-helpers/helpers/reject-by", "media/helpers/reject-by");